//dashboard
export const dashboard = `dashboard`;

//settings
export const general_setting = `general-setting`;
export const game_setting = `game-setting`;
export const leaderboard_setting = `leaderboard-setting`;
export const energy_setting = `energy-setting`;
export const level_setting = `level-setting`;
export const maintenance_setting = `maintenance-setting`;
export const welcome_bonus_setting = `welcome-bonus-setting`;
export const crypto_exchange_setting = `crypto-exchange-setting`;
export const crypto_deposit_setting = `crypto-deposit-setting`;
export const crypto_conversion_setting = `crypto-conversion-setting`;
export const promotion_4gb_setting = `promotion-4gb-setting`;
export const payment_setting = `payment_setting`;
export const reward_system_settings = `reward_system_settings`;
export const jackpot_settings = `jackpot_settings`;
export const buy_energy_settings = `buy-energy`;

// //users
export const users = `users`;
export const usersView = `users/view/:id`;
export const profile = `profile`;
export const changePassword = `change-password`;
export const login = `login`;
export const twofa_setup = `twofa_setup`;
export const forgot_password = `forgot_password`;


// Admin
export const admin = `admin`;

//Language
export const language = `manage-languages`;

//game
export const gameHisory = `game-history`;
export const gameHisoryView = `game-history/view/:id`;
export const gameLeaderboard = `game-leaderboard`;
export const claimHistory = `claim-history`;
export const tasksList = `tasks`;
export const roadmapsList = `roadmaps`;
export const energyPackageList = `energy-packages`;
export const energyPurchaseHistory = `energy-purchases`;
export const roundMultiplier = `round-multiplier`;
export const systemAnnouncement = `system-announcement`;
export const exportRequest = `export-request`;
export const coinHistory = `coin-history`;
export const coinList = `coin-list`;
export const statistics = "statistics";
export const logs = "logs";
// export const subadmins = "sub-admins";
// export const subAdminView = `subadmin/view/:id`;
export const jackpotHistory = `jackpot-history`;
export const jackpotHistoryView = `jackpot-history/view/:id`;
export const weeklyRewardHistory = "weekly-reward-history";

export const mongotoMysql = `mongotoMysql`;
export const removefromMongo = `removefromMongo`;
export const historicalDataSetting = `historical-data-setting`;


export const role = `role`;
export const permission = `permission`;
export const permissionMeta = `permissionMeta`;
